import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InView } from 'react-intersection-observer';
import Controls from './controls/Controls';
import { useExperiencesContext } from '../experiences/Experiences';

import styles from './StickyControls.module.scss';

const StickyControls = ({ isHeaderPeeping, ...props }) => {
  const { isProductCardSizeFlagOn } = useExperiencesContext();

  return (
    <InView initialInView>
      {({ inView, ref }) => (
        <>
          <div ref={ref} className={styles['sticky-sentinel']} />
          <div
            className={classNames(styles['sticky-controls'], {
              [styles.isHeaderPeeping]: isHeaderPeeping,
              [styles['sticky-controls--isStuck']]: !inView,
            })}
            data-test="component-sticky-controls"
          >
            <div
              className={classNames(styles['sticky-controls__controls'], {
                [styles['sticky-controls__controls--change-card-size']]:
                  isProductCardSizeFlagOn,
                [styles['sticky-controls__controls--isStuck']]: !inView,
              })}
              data-test="component-controls-container"
            >
              <Controls {...props} />
            </div>
          </div>
        </>
      )}
    </InView>
  );
};

StickyControls.defaultProps = {
  current: '1',
  isHeaderPeeping: false,
  pages: 1,
  sortBy: '',
};

StickyControls.propTypes = {
  current: PropTypes.string,
  isHeaderPeeping: PropTypes.bool,
  pages: PropTypes.number,
  sortBy: PropTypes.string,
};

export default StickyControls;
